/** Styl obrazu: wyraźny (ostre krawędzie, kontury), malowany (plamy farby), czysty (bez filtra). */
export type ImageStyle = 'wyrazny' | 'malowany' | 'czysty';

/** Ustawienia gracza (per przeglądarka). Zmiana wywołuje słuchaczy, np. Stage i dźwięk. */
export interface Settings {
  style: ImageStyle;
  /** Cienie otoczenia (AO): przyciemnienia w zagłębieniach i przy styku z ziemią — więcej głębi. */
  ao: boolean;
  /** Głośność efektów 0..1. */
  volume: number;
  /** Głośność muzyki 0..1. */
  music: number;
  /** Wysoka jakość = render w min. 1,5× rozdzielczości (gładsze krawędzie, większe obciążenie). */
  highQuality: boolean;
  /** Wstrząsy i szarpnięcia kamery przy mocnych ciosach. */
  shake: boolean;
}

const KEY = 'echa-pustkowi.settings';
/** Wersja ustawienia AO: zapis sprzed zmiany domyślnej wartości nie przenosi starego „włączone”. */
const AO_VERSION = 2;
// AO domyślnie wyłączone: na części kart szum GTAO dawał na całej mapie kropki, które jechały razem z kamerą.
const DEFAULTS: Settings = { style: 'wyrazny', ao: false, volume: 0.6, music: 0.5, highQuality: true, shake: true };

function load(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    const saved = raw ? (JSON.parse(raw) as Partial<Settings> & { paint?: boolean; aoVersion?: number }) : {};
    delete saved.paint; // stare ustawienie z wersji z samym filtrem malowanym
    if (saved.aoVersion !== AO_VERSION) delete saved.ao;
    delete saved.aoVersion;
    const merged = { ...DEFAULTS, ...saved };
    if (!['wyrazny', 'malowany', 'czysty'].includes(merged.style)) merged.style = DEFAULTS.style;
    return merged;
  } catch {
    return { ...DEFAULTS };
  }
}

export const settings: Settings = load();
const listeners = new Set<(s: Settings) => void>();

export function updateSettings(patch: Partial<Settings>): void {
  Object.assign(settings, patch);
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...settings, aoVersion: AO_VERSION }));
  } catch {
    // tryb prywatny — ustawienia działają do końca sesji
  }
  for (const l of listeners) l(settings);
}

export function onSettings(listener: (s: Settings) => void): void {
  listeners.add(listener);
}
